<template>
  <div class="tiny-editor">
    <editor
      :value="value"
      :init="init"
      model-events="change input undo redo"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
// 공지 작성 화면 공용 리치 에디터 (TinyMCE 8 셀프호스팅, GPL 라이선스 키)
// 사용: <tiny-editor v-model="notice_message" upload-prefix="project_cpu/notice/images/" />
const { FileUpload_Async } = require('../../util/fileutil');

const CDN_BASE = 'https://d1r6v24dyewnnj.cloudfront.net/';
// 기존 TipTap 에디터와 동일하게 새 이미지는 기본 가운데 정렬
const DEFAULT_IMG_STYLE = 'display: block; margin-left: auto; margin-right: auto;';

export default {
  name: 'TinyEditor',
  components: {
    Editor: () => import(/* webpackChunkName: "tinymce" */ './tinymce_setup'),
  },
  props: {
    value: { type: String, default: '' },
    // S3 업로드 경로 접두사 (예: "project_cpu/notice/images/")
    uploadPrefix: { type: String, required: true },
    height: { type: Number, default: 600 },
    placeholder: { type: String, default: '공지 내용을 입력하세요.' },
  },
  data() {
    return {
      init: {
        license_key: 'gpl',
        language: 'ko-KR',
        height: this.height,
        menubar: false,
        branding: false,
        promotion: false,
        placeholder: this.placeholder,
        plugins: 'advlist autolink charmap code fullscreen image link lists preview searchreplace table wordcount',
        toolbar:
          'undo redo | blocks fontsize | bold italic underline strikethrough | forecolor backcolor | ' +
          'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | ' +
          'link image table | removeformat | code preview fullscreen',
        toolbar_mode: 'sliding',
        block_formats: '본문=p; 제목 1=h1; 제목 2=h2; 제목 3=h3; 제목 4=h4',
        font_size_formats: '10px 12px 14px 16px 18px 20px 24px 28px 32px 40px',
        content_style:
          'body { font-family: -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", "Malgun Gothic", sans-serif; font-size: 14px; line-height: 1.6; }' +
          ' img { max-width: 100%; height: auto; }',

        // 이미지: 버튼/드래그/붙여넣기 모두 S3 업로드 후 CDN 절대주소로 삽입
        images_upload_handler: (blobInfo) => this.uploadImage(blobInfo),
        automatic_uploads: true,
        paste_data_images: true,
        images_file_types: 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp',

        // 저장된 HTML 이 앱으로 그대로 내려가므로 URL 을 상대경로로 바꾸지 않는다
        relative_urls: false,
        remove_script_host: false,
        convert_urls: false,

        link_default_target: '_blank',
        link_assume_external_targets: 'https',

        setup: (editor) => {
          editor.on('PreInit', () => {
            editor.parser.addNodeFilter('img', (nodes) => {
              nodes.forEach((node) => {
                if (!node.attr('style')) node.attr('style', DEFAULT_IMG_STYLE);
              });
            });
          });
        },
      },
    };
  },
  methods: {
    async uploadImage(blobInfo) {
      const blob = blobInfo.blob();
      const originalName = blobInfo.filename() || 'image.png';
      const dot = originalName.lastIndexOf('.');
      const ext = dot >= 0 ? originalName.substring(dot) : '.png';
      const fileName = Math.random().toString(36).substring(2, 18) + ext;
      const prefix = this.uploadPrefix.endsWith('/') ? this.uploadPrefix : this.uploadPrefix + '/';
      const path = prefix + fileName;

      const ok = await FileUpload_Async(new File([blob], fileName, { type: blob.type }), path);
      if (!ok) {
        // remove: true → 업로드 실패한 이미지는 본문에서 제거
        return Promise.reject({ message: '이미지 업로드에 실패했습니다.', remove: true });
      }
      return CDN_BASE + path;
    },
  },
};
</script>

<style scoped>
.tiny-editor {
  min-height: 200px;
}
</style>
